"use client";

import { api } from "@/lib/api";
import { initApiClient } from "@punchup/utils/apiRegistry";
import { useEffect } from "react";

export function ApiClientInit() {
  useEffect(() => {
    initApiClient(api);
  }, []);

  return null;
}
